import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FILM_VIDEO, HERO_POSTER } from "./Hero";

export const Film = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.92, 1, 0.96]);

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.muted = false;
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <section id="film" ref={ref} data-testid="film-section" className="relative py-24 lg:py-32 bg-[#0A0908]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <motion.div style={{ scale }} className="relative aspect-video overflow-hidden border border-[rgba(212,175,55,0.15)]">
          <video
            ref={videoRef}
            data-testid="film-video"
            className="w-full h-full object-cover"
            src={FILM_VIDEO}
            poster={HERO_POSTER}
            muted
            loop
            playsInline
            autoPlay
            preload="auto"
            onCanPlay={(e) => {
              if (!playing) e.target.play().catch(() => {});
            }}
          />
          <div className={`absolute inset-0 transition-opacity duration-700 ${playing ? "opacity-0" : "opacity-100"} bg-[#0A0908]/40 flex items-center justify-center`}>
            <button
              data-testid="film-play-toggle"
              onClick={toggle}
              className="group relative w-24 h-24 rounded-full border border-[#D4AF37]/60 flex items-center justify-center hover:bg-[#D4AF37]/10 transition-colors duration-500"
              aria-label="Play the film with sound"
            >
              <span className="absolute inset-0 rounded-full border border-[#D4AF37]/30 animate-ping" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
                {playing ? "Pause" : "Sound"}
              </span>
            </button>
          </div>
          <div className="absolute bottom-0 inset-x-0 p-6 bg-gradient-to-t from-[#0A0908]/80 to-transparent pointer-events-none">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A39E93]">The Estate — A Moving Portrait</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
